/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { BedApi } from '../api/bed.api';
import { switchMap, map } from 'rxjs/operators';
import { BedData, Bed } from '../../../interfaces/masters/bed';

@Injectable()
export class BedService extends BedData {

  constructor(private api: BedApi) {
    super();
  }


  list(url: string): Observable<Bed[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Bed>{
      return this.api.getById(url);
  }

  create(url: string, data:Bed): Observable<Bed[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Bed): Observable<Bed> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  search(url: string, data: any): Observable<any> {
    return this.api.add(url,data);
  }
}
